export default {
    instagram: 'Instagram',
    instagram_stories: ' Instagram stories',
    youtube: 'Youtube',
    tiktok: 'Tiktok',
    facebook: 'Facebook',
    twitter: 'X',
    snapchat: 'Snapchat',
};
